import { render, staticRenderFns } from "./SavedPlanUnitCard.vue?vue&type=template&id=05f49004&"
import script from "./SavedPlanUnitCard.vue?vue&type=script&lang=js&"
export * from "./SavedPlanUnitCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports